'use client';

import { useState, useEffect } from 'react';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAccountInfo } from '@/hooks/query/account';
import type { GetSkinModeUrlRequest } from '@/hooks/query/use-account-view';
import dynamic from 'next/dynamic';
import type { LeaveSurveyModalProps } from './types/leave-survey-modal-props';
const LeaveSurveyModal = dynamic<LeaveSurveyModalProps>(() => import('./leave-survey-modal').then(m => m.LeaveSurveyModal));

export const LeaveSurvey = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	const { user } = useAccountInfo();
	const [showModal, setShowModal] = useState<boolean>(false);
	const [switchVersionRequestData, setSwitchVersionRequestData] = useState<GetSkinModeUrlRequest>();

	useEffect(() => {
		const showLeaveSurveyModal = ((event: CustomEvent) => {
			setSwitchVersionRequestData({
				PlatForm: event.detail.platForm,
				SkinMode: event.detail.skinMode
			});
			setShowModal(true);
		}) as EventListener;

		document.addEventListener('show-leave-survey-modal', showLeaveSurveyModal);
		return () => {
			document.removeEventListener('show-leave-survey-modal', showLeaveSurveyModal);
		};
	}, []);

	const isEnable = SiteConfigsData?.EnableGalaxyLeaveSurvey && user?.ActStatus === 2;

	return (
		isEnable ?
			<LeaveSurveyModal
				showModal={showModal}
				setShowModal={setShowModal}
				switchVersionRequestData={switchVersionRequestData}
			/>
			: null
	);
};